import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('message');
const GET_MESSAGES = define('GET_MESSAGES', true);
const SELECT_MESSAGE = define('SELECT_MESSAGE');
const ADD_MESSAGE = define('ADD_MESSAGE', true);
const UPDATE_MESSAGE = define('UPDATE_MESSAGE', true);
const DELETE_MESSAGE = define('DELETE_MESSAGE', true);

const initialState = {
  isLoading: true,
  messages: [],
  selectedMessage: null,
  updating: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MESSAGES.PENDING:
      return {
        ...state,
        isLoading: true,
        messages: [],
        selectedMessage: null
      };
    case GET_MESSAGES.RESOLVED:
      return {
        ...state,
        isLoading: false,
        messages: action.data,
      };
    case SELECT_MESSAGE:
      return {
        ...state,
        selectedMessage: action.message
      };
    case ADD_MESSAGE.PENDING:
    case UPDATE_MESSAGE.PENDING:
    case DELETE_MESSAGE.PENDING:
      return {
        ...state,
        updating: true
      };
    case ADD_MESSAGE.RESOLVED:
    case UPDATE_MESSAGE.RESOLVED:
    case DELETE_MESSAGE.RESOLVED:
      return {
        ...state,
        updating: false
      };
    case ADD_MESSAGE.REJECTED:
    case UPDATE_MESSAGE.REJECTED:
    case DELETE_MESSAGE.REJECTED:
      return {
        ...state,
        updating: false
      };
    default: return state;
  }
};

export const actions = {
  loadMessages: bookingId => ({
    type: GET_MESSAGES,
    promise: api.get(`/bookings/${bookingId}/messages?skip=0&limit=100`),
    error: 'Unable to load messages'
  }),
  selectMessage: message => ({
    type: SELECT_MESSAGE,
    message
  }),
  addMessage: (bookingId, message) => ({
    type: ADD_MESSAGE,
    promise: api.post(`/bookings/${bookingId}/messages/add`, message),
    success: 'Message has been added',
    error: 'Unable to add new message'
  }),
  updateMessage: (bookingId, messageId, original, text, isCensored) => ({
    type: UPDATE_MESSAGE,
    promise: api.put(`/bookings/${bookingId}/messages/${messageId}`, {
      is_censored: isCensored,
      original_text: original,
      text
    }),
    success: 'Message has been updated',
    error: 'Unable to update a message'
  }),
  deleteMessage: (bookingId, messageId) => ({
    type: DELETE_MESSAGE,
    promise: api.delete(`/bookings/${bookingId}/messages/${messageId}`),
    success: 'Message has been deleted',
    error: 'Unable to delete a message'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/message.js